/**
 * Renders a `<script type="application/ld+json">` tag with the given
 * JSON-LD object. Server component — no client JS.
 *
 * Escapes every `<` as its JSON unicode escape (valid inside a JSON string)
 * rather than only replacing a literal `</script>` — the HTML parser matches
 * a script-closing tag case-insensitively (`</SCRIPT>`, `</ScRiPt>`, ...), and
 * this data can carry untrusted text (e.g. public Google review bodies).
 */
export function JsonLdScript({ data }: { data: Record<string, unknown> }) {
  const json = JSON.stringify(data).replace(/</g, '\\u003c');
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}
